import React from 'react';

const BlankMasterPage = ({ children, style }) => {
    return (<div style={style}>{children}</div>);
};

export default BlankMasterPage;

